// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"78":"4f30eef3","293":"b912b857","338":"0eef0592","373":"e837389c","442":"6f7cf4f8","447":"fa456710","576":"8b810fa3","586":"0a3f20ec","753":"d7697aba","772":"a9bebafd","775":"4e84724c","823":"242c5e4e","838":"5616d16b","909":"67f1f0d4","990":"1636b29a"}[chunkId] + ".js";
};